import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Scale, BadgeCheck } from "lucide-react";
import { fadeUp } from "./anim";

const WHY = [
  { icon: ShieldCheck, title: "Protect your property", desc: "Spot higher-risk booking patterns before you confirm — parties, damage, refund and communication signals." },
  { icon: Scale, title: "Stay compliant", desc: "No blacklists, no guest names, no accusations. Just neutral guidance based on the details you provide." },
  { icon: BadgeCheck, title: "Consistent decisions", desc: "The same booking always scores the same way — a fair, repeatable framework across your whole portfolio." },
];

export const WhyHosts = () => (
  <section id="why" className="border-y bg-secondary/40">
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
      <motion.div {...fadeUp} className="mx-auto max-w-2xl text-center">
        <h2 className="font-display text-3xl font-semibold tracking-tight">Why hosts use it</h2>
        <p className="mt-3 text-muted-foreground">A protective, compliance-first way to vet bookings.</p>
      </motion.div>
      <div className="mt-10 grid gap-5 md:grid-cols-3">
        {WHY.map((s, i) => (
          <motion.div key={s.title} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.08 }}
            className="rounded-xl border bg-card p-6">
            <s.icon className="h-6 w-6 text-[hsl(var(--risk-low))]" />
            <h3 className="mt-4 font-display text-lg font-semibold">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
